import Vue from 'vue'
import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'

const pjson = require('../../package.json')

const bugsnagClient = bugsnag({
  apiKey: '739dce21a9cb201a188670164aededc4',
  releaseStage: process.env.VUE_APP_STAGE,
  notifyReleaseStages: ['production', 'staging', 'beta'],
  appVersion: pjson.version,
})

bugsnagClient.use(bugsnagVue, Vue)
